import React from "react";
import { DeliveryContext } from "./delivery-context";
import { usePageDeliveryHook } from "./delivery-hooks";

export function PageContextDeliveryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = usePageDeliveryHook();

  return (
    <DeliveryContext.Provider value={value}>
      {children}
    </DeliveryContext.Provider>
  );
}
